import React, { PureComponent } from 'react';
import { css } from '@emotion/css';
import AccessDropdown from '../../../../common/components/AccessControl/AccessDropdown';
import { WRITE_PERMISSIONS } from '../../../routers/RouterServices';

import Tooltip from '../../../../common/components/core/Tooltip';
import { strToTitleCase } from '../../../../main/support/utils';
import { DA_PAUSED_STATUS, DA_STATUS_OPTIONS, DA_STATUS_COLORS, ACTIVE } from '../discoAdsConstants';

const dot = (color) => ({
  alignItems: 'center',
  display: 'flex',
  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 9,
    marginLeft: 9,
    height: 10,
    width: 10,
  },
});

const CAMPAIGN_TYPE = 'campaign';
const CREATIVE_TYPE = 'creative';
const AD_GROUP_TYPE = 'ad-group';

class DiscoAdsTableStatusWrapper extends PureComponent {
  _handleStatusChange = ({ value }) => {
    const { onChange, id } = this.props;
    onChange({
      id,
      status: value,
    });
  };

  _isDropdownDisabled = () => {
    const { type, campaignIsPaused, adGroupIsPaused } = this.props;
    if (type !== CAMPAIGN_TYPE && campaignIsPaused) {
      return true;
    }
    if (type === CREATIVE_TYPE && adGroupIsPaused) {
      return true;
    }
    return false;
  };

  _determineDisabledDropdownValue = () => {
    const { type } = this.props;
    if (type === AD_GROUP_TYPE) {
      return DA_PAUSED_STATUS.campaign;
    }
    return DA_PAUSED_STATUS.adGroup;
  };

  _determineDotColor = () => {
    const { val } = this.props;
    const { active, paused } = DA_STATUS_COLORS;
    return val === ACTIVE ? active : paused;
  };

  render() {
    const { val } = this.props;
    const { disabled, selectedOptionBackgroundColor, optionTextColor } = DA_STATUS_COLORS;
    const formattedVal = {
      value: val,
      label: strToTitleCase(val),
    };
    const dropdownIsDisabled = this._isDropdownDisabled();
    const disabledDropdownValue = dropdownIsDisabled ? this._determineDisabledDropdownValue() : {};
    const dotColor = dropdownIsDisabled ? disabled : this._determineDotColor();

    const styles = {
      statusCellContainer: css({
        flex: 1,
        minWidth: dropdownIsDisabled ? '180px' : '120px',
      }),
    };

    const dropDownCustomStyling = {
      // for more context visit: https://react-select.com/home#custom-styles
      control: (styles) => ({
        ...styles,
        backgroundColor: 'transparent',
        borderRadius: '2px',
      }),
      option: (styles, { data, isSelected, isFocused }) => {
        const isFocusedBackgroundColor = data.backgroundColor;
        return {
          ...styles,
          backgroundColor: isSelected ? selectedOptionBackgroundColor : isFocused ? isFocusedBackgroundColor : null,
          color: optionTextColor,
          ...dot(data.dotColor),
        };
      },
      singleValue: (styles) => ({ ...styles, ...dot(dotColor) }),
    };

    const Component = (
      <AccessDropdown
        clearable={false}
        outerClassName={styles.statusCellContainer}
        options={DA_STATUS_OPTIONS}
        value={dropdownIsDisabled ? disabledDropdownValue : formattedVal}
        onChange={this._handleStatusChange}
        i13nLabel="Disco Ads Status Dropdown"
        styles={dropDownCustomStyling}
        disabled={dropdownIsDisabled}
        {...WRITE_PERMISSIONS.MOBILE_SEARCH}
      />
    );
    return (
      <div>
        {dropdownIsDisabled && (
          <div>
            <Tooltip body={disabledDropdownValue.description} children={Component} />
          </div>
        )}
        {!dropdownIsDisabled && Component}
      </div>
    );
  }
}

export default DiscoAdsTableStatusWrapper;
